export const TOOLS_COLOR_PICKER_WIDTH = '300px';
export const TOOLS_COLOR_PICKER_TOP = '1%';
export const TOOLS_COLOR_PICKER_LEFT = '70px';
